// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3312":"3ac5afc2","7882":"9610f8e3"}[chunkId] + ".chunk.css";
};